import http from "@/http-common";
import Message, {MessageDTO} from "@/api/Message";

class MessageService {
    async getMessages(): Promise<Message[]> {
        const url = '/customer/ajaxMessage/getMessages';
        const response = await http.get<MessageDTO[]>(url);
        return response.data.map(messageDTO => new Message(messageDTO));
    }
}

export default new MessageService();